<template>
  <div class="auth-card">
    <h2>خوش آمدید</h2>
    <p class="muted">ورود به حساب کاربری</p>
    <form @submit.prevent="onSubmit">
      <div class="field">
        <label>ایمیل</label>
        <input v-model.trim="email" type="email" placeholder="example@domain.com" />
      </div>
      <div class="field">
        <label>رمز عبور</label>
        <input v-model="password" :type="showPassword ? 'text' : 'password'" placeholder="••••••••" />
      </div>
      <div class="row">
        <label class="checkbox">
          <input type="checkbox" v-model="remember" />
          <span>مرا به خاطر بسپار</span>
        </label>
        <a href="#" class="link">فراموشی رمز؟</a>
      </div>
      <button class="primary" :disabled="!canSubmit">ورود</button>
    </form>
    <p class="switch">حساب ندارید؟ <router-link to="/register">ثبت‌نام</router-link></p>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useMutation } from '@vue/apollo-composable'
import { useToast } from '../ui/toast'
import { LOGIN_MUTATION } from '../api/mutations'
import { useRouter } from 'vue-router'

const email = ref('')
const password = ref('')
const remember = ref(true)
const showPassword = ref(false)
const error = ref('')
const toast = useToast()
const router = useRouter()

const canSubmit = computed(() => /.+@.+\..+/.test(email.value) && password.value.length >= 8)

const { mutate: loginMutate } = useMutation(LOGIN_MUTATION)

async function onSubmit() {
  error.value = ''
  if (!canSubmit.value) {
    error.value = 'اطلاعات وارد شده صحیح نیست'
    toast?.show({ text: error.value, type: 'error' })
    return
  }
  try {
    const { data } = await loginMutate({ data: { email: email.value, password: password.value } })
    if (!data || !data.login) {
      error.value = 'ایمیل یا رمز عبور نادرست است'
      toast?.show({ text: error.value, type: 'error' })
      return
    }
    const { accessToken, tokenType } = data.login
    if (remember.value) {
      localStorage.setItem('auth_token', accessToken)
      localStorage.setItem('token_type', tokenType || 'bearer')
    } else {
      sessionStorage.setItem('auth_token', accessToken)
      sessionStorage.setItem('token_type', tokenType || 'bearer')
    }
    error.value = ''
    toast?.show({ text: 'ورود موفقیت‌آمیز بود', type: 'success' })
    router.push('/dashboard')
  } catch (e) {
    const msg = (e?.graphQLErrors && e.graphQLErrors[0]?.message) || 'مشکلی رخ داد، دوباره تلاش کنید'
    error.value = msg
    toast?.show({ text: msg, type: 'error' })
  }
}
</script>

<script>
export default { name: 'LoginView' }
</script>

<style scoped>
.auth-card { background: var(--card); border:1px solid var(--border); border-radius:16px; padding:24px; box-shadow: 0 8px 24px rgba(0,0,0,0.06); width: 100%; max-width: 400px; margin: 0 auto; }
h2 { margin:0 0 4px; font-size:22px; }
.muted { margin:0 0 20px; color: var(--muted); }
.field { position:relative; display:flex; flex-direction:column; gap:8px; margin-bottom:16px; }
label { font-size:13px; color: var(--muted); }
input { border:1px solid var(--border); border-radius:10px; padding:12px 14px; font-size:14px; outline:none; background:#fafafa; }
input:focus { border-color: var(--accent); background:#fff; box-shadow: 0 0 0 4px rgba(59,130,246,0.12); }
.toggle { position:absolute; right:8px; top:31px; background:transparent; border:none; color:var(--muted); font-size:12px; padding:6px 8px; border-radius:6px; cursor:pointer; }
.toggle:hover { color: var(--accent); background: rgba(59,130,246,0.08); }
.row { display:flex; align-items:center; justify-content:space-between; margin-bottom:16px; }
.checkbox { display:flex; align-items:center; gap:8px; font-size:13px; color: var(--muted); }
.link { color: var(--accent); text-decoration:none; font-size:13px; }
.link:hover { color: var(--accent-dark); }
.primary { width:100%; background: #000000; color:#ffffff; border:none; border-radius:10px; padding:12px 14px; font-weight:600; cursor:pointer; }
.primary:disabled { opacity:0.6; cursor:not-allowed; }
.switch { margin-top:14px; text-align:center; color: var(--muted); }
.switch a { color: var(--accent); text-decoration:none; }
.error { margin-top:10px; color: #ef4444; font-size:13px; }
</style>
